import {post} from './httpBase'
//获取验证码
export function getPhoneCode(params) {
    return post('/user/sms', params)
}
//验证码自动验证
export function validation(params) {
    return post('/user/sms/validation', params)
}
//密码重置完成
export function complete(params) {
    return post('/user/dispatcher/forgetpasswd', params)
}
//个人中心重置密码
export function changePwd(params) {
    return post('/user/dispatcher/changepasswd', params)
}
//退出登录
export function reg(params) {
    return post('/region/invoke', params)
}
//忘记密码
export function recoveryPwd(params) {
    return post('/region/changePassword', params)
}
//登录
export function login(params) {
    return post('/auth/oauth2/token', params)
}



// WEBPACK FOOTER //
// ./src/service/loginService.js